import React, { useState } from 'react';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import withStyles from '@material-ui/core/styles/withStyles';

export const InputBox = ({ classes, onInput }) => {
  const [value, setValue] = useState('');

  const onChange = (e) => {
    const { value } = e.target;
    setValue(value);
    onInput(value);
  };

  const onReset = () => {
    setValue('');
    onInput('');
  };

  return (
    <div>
      <Input
        id="text"
        value={value}
        autoFocus={true}
        onChange={onChange}
        disableUnderline={true}
        classes={{
          root: classes.root,
        }}
        inputProps={{
          'aria-label': 'Search',
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={onReset}
            >
              <HighlightOffIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </div>
  );
};

export default withStyles({
  root: {
    width: '100%',
    height: '50px',
    border: '1px solid #AAA',
    padding: '20px',
    borderRadius: '50px',
  },
})(InputBox);
